module.exports = __webpack_public_path__ + "static/media/soso-gray.942e9cbd.svg";